import { EnvInterface } from '@interfaces';
​
export const environment: EnvInterface = {
  production: false,
  apiUrl: 'https://dev-wvpp.wlcmapps.com/api',
  apiUrlBasic: 'https://dev-wvpp.wlcmapps.com',
  whitelistedDomains: ['https://dev-wvpp.wlcmapps.com'],
};
